export const _GET_NOTICE = '_GET_NOTICE';

export const _GET_NAV_NOTICE = '_GET_NAV_NOTICE';
